import { createApp } from "vue";
import TeacherAssignmentsManager from "./components/TeacherAssignmentsManager.vue";
import { parseBoolean } from "./utils/parseBoolean";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-teacher-assignments]";

export function initTeacherAssignmentsApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(TeacherAssignmentsManager, {
      initialState: payload.initialState || {},
      subjectOptionsRaw: Array.isArray(payload.subjectOptions) ? payload.subjectOptions : [],
      legendConfig: Array.isArray(payload.legendConfig) ? payload.legendConfig : [],
      qualificationLabels:
        payload.qualificationLabels && typeof payload.qualificationLabels === "object"
          ? payload.qualificationLabels
          : {},
      canEdit: parseBoolean(payload.canEdit),
      canOpenReadonlyModal: parseBoolean(payload.canOpenReadonlyModal),
      apiUrl: payload.apiUrl || "",
      deleteTemplate: payload.deleteTemplate || "",
      csrfToken: payload.csrfToken || "",
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
